'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutesAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/minutesAgo.js
// module id = 360
// module chunks = 1